<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    {{ gridOptions.abc }}
    <ag-grid-vue
      :id="model.$ID"
      :style="gridStyles"
      :class="evaluateClasses(classes, 'ag-theme-material ag-grid-editor-mode')"
      :columnDefs="_columns"
      :defaultColDef="defaultColDef"
      :rowData="_rows"
      :gridOptions="gridOptions"
      :treeData="model.TreeData"
      :animateRows="true"
      :groupDefaultExpanded="-1"
      :getDataPath="getDataPath"
      :autoGroupColumnDef="autoGroupColumnDef"
      :frameworkComponents="frameworkComponents"
      @gridButtonClicked="onGridButtonClicked"
    ></ag-grid-vue>
  </dr-wrapper>
  
  <ag-grid-vue
    v-else-if="isVisible"
    :id="model.$ID"
    :style="gridStyles"
    :class="evaluateClasses(classes, 'ag-theme-material')"
    :columnDefs="appliedColumnsRules"
    :defaultColDef="defaultColDef"
    :rowData="_rows"
    :gridOptions="gridOptions"
    :treeData="model.TreeData"
    :animateRows="true"
    :groupDefaultExpanded="-1"
    :getDataPath="getDataPath"
    :autoGroupColumnDef="autoGroupColumnDef"
    :frameworkComponents="frameworkComponents"
    @gridButtonClicked="onGridButtonClicked"
    @cell-editing-stopped="onCellEditingStopped"
  ></ag-grid-vue>
</template>

<script>
/* eslint-disable */
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'
import actionMixin from '../../mixins/actions-mixin'
import vue from 'vue'
import ButtonCellRenderer from '../../components/gridCellRenderers/ButtonCellRenderer.vue'
import NumericCellRenderer from '../../components/gridCellRenderers/NumericCellRenderer.vue'
import CheckboxCellRenderer from '../../components/gridCellRenderers/CheckboxCellRenderer.vue'
import uk from '../../langs/agGrid/uk.json'
import ru from '../../langs/agGrid/ru.json'
import en from '../../langs/agGrid/en.json'
import 'ag-grid-enterprise'
import agGridRowsSorting from './rowsSorting'
import { LicenseManager } from 'ag-grid-enterprise'
import { GridColumnsSettings } from './GridColumnsSettings'

const agGridLicenzeKey =
  'CompanyName=IT,LicensedApplication=IT,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-022454,ExpiryDate=19_November_2022_[v2]_MTY2ODgxNjAwMDAwMA==dffb2e7bf0aa0c6b199f4bf3f25741d2'

LicenseManager.setLicenseKey(agGridLicenzeKey)

export default {
  mixins: [mixin, inputMixin, actionMixin, widgetsWrapperMixin],
  components: {
    'ag-grid-vue': () => import(/* webpackChunkName: "chunk_ag-grid-vue" */ 'ag-grid-vue').then((m) => m.AgGridVue),
    ButtonCellRenderer,
    CheckboxCellRenderer
  },
  data() {
    return {
      timerId: null,
      objectWithWidthParameters: {},
      defaultColumns: [{ headerName: this.$t('agGrid.column1') }, { headerName: this.$t('agGrid.column2') }],
      defaultColDef: {
        valueGetter: (d) => {
          var val = d.data[d.colDef.field]
          if (d.colDef.hideZero && val === 0) {
            return ''
          }
          return val
        }
      },
      gridOptions: {
        onFirstDataRendered: this.gridColumnsSettings?.columnHeightSetter, // Начальная установка высоты колонок
        enableRtl: this.$vuetify.rtl,
        onRowSelected: this.onRowSelected, // Выделение строки
        onGridReady: this.onGridReady, // Загрузка грида
        rowSelection: 'single', // Возможность выбрать одну строку
        suppressCellSelection: true, // Убрать выделение ячейки
        onColumnResized: this.onColumnResized, // Изменение ширины колонки
        localeText: {
          noRowsToShow: this.$t('agGrid.noRowsToShow'),
          contains: this.$t('agGrid.contains'),
          notContains: this.$t('agGrid.notContains'),
          startsWith: this.$t('agGrid.startsWith'),
          endsWith: this.$t('agGrid.endsWith'),
          equals: this.$t('agGrid.equals'),
          lessThan: this.$t('agGrid.lessThan'),
          inRange: this.$t('agGrid.inRange'),
          lessThanOrEqual: this.$t('agGrid.lessThanOrEqual'),
          greaterThan: this.$t('agGrid.greaterThan'),
          greaterThanOrEqual: this.$t('agGrid.greaterThanOrEqual'),
          notEqual: this.$t('agGrid.notEqual'),
          andCondition: this.$t('agGrid.andCondition'),
          orCondition: this.$t('agGrid.orCondition'),
          filterOoo: this.$t('agGrid.filter'),
          pinColumn: this.$t('agGrid.pinColumn'),
          autosizeThiscolumn: this.$t('agGrid.autosizeThiscolumn'),
          autosizeAllColumns: this.$t('agGrid.autosizeAllColumns'),
          resetColumns: this.$t('agGrid.resetColumns'),
          export: this.$t('agGrid.export'),
          csvExport: this.$t('agGrid.csvExport'),
          excelExport: this.$t('agGrid.excelExport'),
          excelXmlExport: this.$t('agGrid.excelXmlExport'),
          pinLeft: this.$t('agGrid.pinLeft'),
          pinRight: this.$t('agGrid.pinRight'),
          noPin: this.$t('agGrid.noPin'),
          copy: this.$t('agGrid.copy'),
          copyWithHeaders: this.$t('agGrid.copyWithHeaders'),
          paste: this.$t('agGrid.paste'),
          searchOoo: this.$t('agGrid.searchOoo'),
          loadingOoo: this.$t('agGrid.loadingOoo'),
          expandAll: this.$t('agGrid.expandAll'),
          collapseAll: this.$t('agGrid.collapseAll')
        }
      },
      frameworkComponents: {
        CheckboxCellRenderer: vue.component('CheckboxCellRenderer', CheckboxCellRenderer),
        ButtonCellRenderer: vue.component('ButtonCellRenderer', ButtonCellRenderer),
        NumericCellRenderer: vue.component('NumericCellRenderer', NumericCellRenderer)
      }
    }
  },
  i18n: {
    messages: {
      uk,
      ru,
      en
    }
  },
  computed: {
    gridColumnsSettings() {
      return new GridColumnsSettings(this._rows, this.gridOptions, this.model)
    },
    gridStyles() {
      return {
        width: this.model.Width || '100%',
        height: this.model.Height || '500px'
      }
    },
    appliedColumnsRules() {
      return agGridRowsSorting.applyRowsSorting(this._columns)
    },
    // Колонка группы
    autoGroupColumnDef() {
      if (!this.model?.TreeData) {
        return
      }

      let groupColumn = {
        headerName: this.model?.GroupColumnName || this.$t('agGrid.defaultGroupColumnName'),
        field: this.model?.PathFieldName,
        filter: this.model?.GroupColumnFilter,
        width: this.model?.GroupColumnWidth,
        minWidth: this.model?.GroupColumnMinWidth,
        resizable: this.model?.GroupColumnResizable,
        sortable: this.model?.GroupColumnSortable,
        floatingFilter: this.model?.GroupColumnFloatingFilter
      }

      groupColumn.valueGetter = this.groupValueGetter.bind(this)
      // Установка стилей
      groupColumn.cellStyle = this.groupCellStyle()

      let columnsFromCache = JSON.parse(localStorage.getItem(this.keyForColumnState))
      if (!columnsFromCache?.[groupColumn?.field]) {
        return groupColumn
      }

      // Установить размер колонки, если она изменялась ранее
      groupColumn.width = columnsFromCache[groupColumn.field]

      return groupColumn
    },

    _columns() {
      if (this.isInEditorMode) {
        var tempColumn = this.model.Columns
        if (tempColumn?.columns?.length && !tempColumn?.isReference) {
          let arrayColumns = tempColumn.columns.map((x) => {
            return { headerName: x.headerName }
          })
          return this.gridColumnsSettings?.getColumnsWithWidthFromCache(arrayColumns, this.keyForColumnState)
        }
        return this.defaultColumns
      }

      let columns = this.defaultColumns

      // Отображение колонок по полю columns "Перечень колонок"
      if (this.model.Columns && !this.model.Columns.isReference && this.model.Columns.columns && this.model.Columns.columns.length) {
        columns = this.model.Columns.columns

        columns = this.gridColumnsSettings?.processingCellStyle(columns)
        columns = this.gridColumnsSettings?.getColumnsWithWidthFromCache(columns, this.keyForColumnState)
      }
      // Cтарый способ получения колонок по ссылке
      if (typeof (this.model.Columns && this.model.Columns) == 'string') {
        const currentColumns = this.getColumnsHeader(this.model.Columns)
        columns = this.gridColumnsSettings?.getColumnsWithWidthFromCache(currentColumns, this.keyForColumnState)
      }
      // Отображение колонок по полю reference "Ссылка на поле"
      if (this.model.Columns && this.model.Columns.isReference && this.model.Columns.reference) {
        const currentColumns = this.getColumnsHeader(this.model.Columns.reference)
        columns = this.gridColumnsSettings?.getColumnsWithWidthFromCache(currentColumns, this.keyForColumnState)
      }
      //Если есть кнопки и ранее колонки с кнопками не было, добавить колонку для кнопок
      if (this.model?.Buttons?.length > 0 && columns.at(-1)?.field !== 'buttonsField') {
        columns.push({
          field: 'buttonsField',
          cellRenderer: 'ButtonCellRenderer',
          buttonsList: [...this.model.Buttons],
          headerName: '',
          pinned: 'right',
          width: 90,
          cellStyle: { display: 'flex', 'align-items': 'center' }, //колонка с кнопками по средине строки вертикально
          inPopup: true,
          resizable: true
        })
      }

      columns.forEach((element) => {
        // Установка редактироваемых полей для колонки
        this.gridColumnsSettings?.setEditableColumn(element)
        // Установка поведения textWrapping для колонки и строки
        this.gridColumnsSettings?.setTextWrapping(element)
        // Если есть вложенность в объект
        if (element.field && element.field.includes('.')) {
          element.valueGetter = this.gridColumnsSettings?.valueGetter
        }
      })
      return columns
    },
    _rows() {
      return this.isInEditorMode ? [] : this.getExternalSourceField(this.model.Rows)
    },
    keyForColumnState() {
      return `${this.$route.name}-${this.model.$ID}`
    }
  },
  methods: {
    // Вызов действия после окончания редактирования
    onCellEditingStopped(event) {
      this.invokeActionOnClick(this.model.OnClickAction, { column: event.colDef, rowIndex: event.rowIndex })
    },
    // Функция которая привязана к событию изменения размера колонки
    onColumnResized(event) {
      if (!event?.finished && !event?.column) {
        return
      }
      // Задать высоту колонки в зависимости от её содержимого
      if (event?.column?.colDef?.columnTextWrapping) {
        this.gridColumnsSettings?.columnHeightSetter()
      }
      // Задать высоту строки в зависимости от её содержимого
      if (event?.column?.colDef?.rowTextWrapping) {
        this.gridOptions.api.resetRowHeights()
      }

      let name = event?.column?.colDef?.field
      let width = event?.column?.actualWidth
      this.objectWithWidthParameters[name] = width
      let key = this.keyForColumnState // Если перешли по другому маршруту, сохранить по ключу прошлого маршрута
      clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        this.gridColumnsSettings?.addToCache(key, this.objectWithWidthParameters)
      }, 5000)
    },

    getColumnsHeader(ref) {
      let columns = this.getDataSourceField(ref)
      // Проверка является ли columns массивом в поле columns
      if (!Array.isArray(columns)) {
        return this.defaultColumns
      }
      columns = this.gridColumnsSettings?.processingCellStyle(columns)
      return columns
    },

    groupCellStyle() {
      return this.gridColumnsSettings?.getStyleFunction(() => this.evaluateExpression(this.model.GroupCellStyle))
    },
    onGridButtonClicked(e) {
      if (e.OnClickAction !== undefined) {
        this.invokeActionOnClick(e.OnClickAction, e.data)
        return
      }

      this.$emit('callDataSourceAction', {
        action: 'gridButtonClicked',
        params: e
      })
    },
    groupValueGetter(d) {
      var pathFieldName = this.model.PathFieldName || 'path'
      var groupTitleFieldName = this.model.GroupTitleFieldName || 'groupTitle'
      return d.data[groupTitleFieldName] || this.getPath(d.data[pathFieldName]).pop()
    },
    getPath(path) {
      if (path.startsWith('/')) {
        path = path.substring(1)
      }
      if (path.endsWith('/')) {
        path = path.substr(0, path.length - 1)
      }
      return path.split('/')
    },
    getDataPath(data) {
      let fieldName = this.model.PathFieldName || 'path'
      return this.getPath(data[fieldName])
    },

    // Выделение строки
    onRowSelected(event) {
      if (!event.node.selected) {
        return
      }
      this.$emit('callDataSourceAction', {
        action: 'gridRowSelected',
        params: event.data
      })
    },
    // Срабатывает при загрузки грида
    onGridReady(event) {
      if (this._rows && this._rows.length) {
        event.api.rowModel.nodeManager.selectionController.selectIndex(0)
      }
    }
  }
}
</script>

<style>
.ag-grid-editor-mode {
  outline: 1px solid lightgray;
  height: 150px;
}
</style>
